<template>
  <div :id="id" class="carousel splide">
    <div class="splide__track">
      <ul class="splide__list">
        <slot></slot>
      </ul>
    </div>
  </div>
</template>

<script>
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/dist/css/splide.min.css';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'loop',
    },
    padding: {
      type: String,
      default: '40px',
    },
    slidesPerPage: {
      type: Number,
      default: 4,
    },
    speed: {
      type: Number,
      default: 1,
    },
    gap: {
      type: String,
      default: '24px',
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      elements: null,
    };
  },
  mounted() {
    this.$nextTick(this.filterOutEmptySliderElements());
  },
  watch: {
    elements: function(val) {
      if (!!val) {
        var splide = new Splide(`#${this.id}`, this.options).mount(this.autoplay ? { AutoScroll } : {});
        val.forEach(el => {
          splide.add(el.elm.outerHTML);
        });

        if (this.autoplay) {
          var slide = document.getElementById(this.id).querySelector(`.splide__track`);
          slide.addEventListener('mouseover', event => {
            splide.Components.AutoScroll.pause();
          });
          slide.addEventListener('mouseleave', () => {
            splide.Components.AutoScroll.play();
          });
          slide.addEventListener('focus', () => {
            splide.Components.AutoScroll.pause();
          });
          slide.addEventListener('focusout', () => {
            splide.Components.AutoScroll.play();
          });
        }
      }
    },
  },
  computed: {
    options() {
      return {
        type: this.type,
        pagination: false,
        perPage: this.slidesPerPage,
        perMove: 1,
        gap: this.gap,
        padding: this.padding,
        breakpoints: this.responsive,
        focus: 'center',
        autoWidth: true,
        drag: false,
        autoHeight: true,
        autoScroll: {
          pauseOnHover: false,
          pauseOnFocus: false,
          speed: this.speed,
          autoStart: this.autoplay,
        },
      };
    },
    responsive() {
      return {
        1090: {
          perPage: 3,
        },
        768: {
          perPage: 2,
          drag: true,
        },
      };
    },
  },
  methods: {
    filterOutEmptySliderElements() {
      this.elements = this.$slots.default.filter(el => !!el.tag);
    },
  },
};
</script>
